// mantine
import { Anchor, Pill, UnstyledButton } from '@mantine/core';
// icons
import { Trash2, Edit } from 'lucide-react';
// components
import { PopoverButton } from '@newo/ui-kit';
import type { TWebhook, TWebhookData } from '@newo/api/gateway';
import WebhookForm from '@/pages/Integrations/components/Webhooks/components/WebhookForm';
// utils
import { cn } from '@/utils';
import { useWebhookDeleteMutation } from '@/services/webhooks/webhooks.queries.ts';
// assets
import styles from '@/pages/Integrations/components/Webhooks/components/WebhookItem/WebhookItem.module.css';

interface WebhookItemProps {
    webhook: TWebhook;
    onUpdate: (data: TWebhookData) => void;
    onDelete: () => void;
}

const WebhookItem = ({ webhook, onDelete, onUpdate }: WebhookItemProps) => {
    const {
        mutate: deleteWebhook,
        isPending,
        isSuccess
    } = useWebhookDeleteMutation();

    const handleDelete = () => {
        deleteWebhook(
            { webhookId: webhook.id },
            {
                onSuccess() {
                    onDelete();
                }
            }
        );
    };

    return (
        <article
            className={cn(styles.item, {
                [styles.isPending]: isPending || isSuccess
            })}
        >
            <div className={styles.actions}>
                <PopoverButton trigger={<Edit />}>
                    {(close) => (
                        <WebhookForm
                            connectorIdn={webhook.connector_idn}
                            webhook={webhook}
                            onClose={close}
                            onSubmit={onUpdate}
                        />
                    )}
                </PopoverButton>
                <UnstyledButton className="text-red-6" onClick={handleDelete}>
                    <Trash2 />
                </UnstyledButton>
            </div>
            <div className={styles.label}>Idn</div>
            <div>{webhook.idn}</div>
            <div className={styles.label}>url</div>
            <div className="break-all">
                <Anchor href={webhook.url} size="xs" target="_blank">
                    {webhook.url}
                </Anchor>
            </div>
            {webhook.description ? (
                <>
                    <div className={styles.label}>description</div>
                    <div>{webhook.description}</div>
                </>
            ) : undefined}
            <div className={styles.label}>commands</div>
            <div className="flex gap-2">
                {webhook.command_idns.map((c) => (
                    <Pill key={c}>{c}</Pill>
                ))}
            </div>
        </article>
    );
};

export default WebhookItem;
